import UiPageList from "./UiPageList";
import DtoListItemCompanyCharge from "./DtoListItemCompanyCharge";
import UiSelectOption from "./UiSelectOption";

/**
 * 计费重量分页列表
 * @description 自动生成的代码,请勿修改
 */
export default class DtoPageListCompanyCharge extends UiPageList<DtoListItemCompanyCharge, string> {
    constructor() {
        //无参构造函数
        super()
        this.Selects = [];
        this.PageIndex = 0;
        this.PageSize = 0;
        this.TotalCount = 0;
        this.TotalPages = 0;
        this.HasPrevPages = false;
        this.HasNextPages = false;
    }

    [proName: string]: any;
    /**
     * 
     */
    Selects?: UiSelectOption<string>[];
}

/**
 * 计费重量分页列表-表单校验
 */
export const DtoPageListCompanyChargeRules = {
}
